import LandingPage from "../LandingPage.jsx";

export default function LandingDa() {
  return <LandingPage forcedLang="da" />;
}